import { reduxKey } from '../../constants';
import { createAction } from 'redux-actions';

export const hydrateStorage = createAction(
  `${reduxKey}.DAMZ_STORE_LOAD`,
  store => ({ store })
);

export const saveEnterHandling = createAction(
  `${reduxKey}.DAMZ_STORE_SAVE_ENTER`,
  handling => ({ handling })
);

export const saveGoodState = createAction(
  `${reduxKey}.DAMZ_STORE_GOOD_STATE`,
  () => ({})
);
